import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Card, CardBody, CardHeader, CardFooter } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';


import moment from 'moment';
import 'moment/locale/es'; // Importar el idioma español  
import { getDashboardStatus } from '../../../../slices/thunks';
import BarChart from '../../../../Components/Common/Charts/BarChart';
import ODoughnutChart from '../../../../Components/General/Chart/ODoughnutChart';
import OPlaceholder from '../../../../Components/OElements/OPlaceholder';
moment.locale('es'); // Configurar el idioma


const PpeStatusInfo = ({ title, dataColors, um = '', establishment_id = null, minHeight, maxHeight }) => {
    const dispatch = useDispatch();
    const [selectedFilter, setSelectedFilter] = useState('1M');

    const [chartData, setChartData] = useState({ series: [], categories: [], fuelSummary: [] });

    const selectorPersonalProtectiveEquipment = createSelector(
        state => state.PersonalProtectiveEquipments,
        data => ({
            isLoading: data.isLoadingDashboardStatus,
            dashboardStatus: data.dashboardStatus,
        })
    );

    const { isLoading, dashboardStatus } = useSelector(selectorPersonalProtectiveEquipment);


    useEffect(() => {
        dispatch(getDashboardStatus({ 'filter': selectedFilter, 'establishment_id': establishment_id }));
    }, []);

    const handleFilterChange = (filter) => {
        setSelectedFilter(filter);
        dispatch(getDashboardStatus({ 'filter': filter, 'establishment_id': establishment_id }));
    };

    const seriesChart = dashboardStatus.map(item => item.count)
    const colorsChart = dashboardStatus.map(item => item.txcolor)
    const labelsChart = dashboardStatus.map(item => item.name)

    const labelsHeaderChart = ['Estado', 'Total', '%'];

    if (isLoading) {
        return <OPlaceholder />;
    }

    if (!dashboardStatus) {
        return (
            <Card className='p-0 mb-2'>
                <CardHeader className='p-2 align-items-center d-flex'>
                    <h5 className="flex-grow-1 m-0">{title}</h5>
                </CardHeader>
                <CardBody className='p-2'>
                    <div className="d-flex justify-content-center align-items-center p-3">
                        <div className="text-center">
                            <div className="avatar-md">
                                <span className="avatar-title bg-info-subtle rounded-circle fs-1">
                                    <i className="ri-gas-station-fill text-info"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </CardBody>
                <CardFooter className="m-0 p-2 text-center">
                    <h6 className="mb-0 p-0 text-wrap w-100">
                        <span className="fs-11 badge bg-info-subtle text-info text-wrap">
                            No cuenta con registros de asignación de Equipos de Protección Personal
                        </span>
                    </h6>
                </CardFooter>
            </Card>
        );
    }

    return (
        <React.Fragment>
            <ODoughnutChart
                title={title}
                seriesChart={seriesChart}
                labelsChart={labelsChart}
                colorsChart={colorsChart}
                legendPosition={'bottom'}
                with_total={false}
                height={'100%'}
                labelsHeaderChart={labelsHeaderChart}
                um={um}
                selectedFilter={selectedFilter}
                onFilterChange={handleFilterChange}
            />
        </React.Fragment>
    );
};

export default PpeStatusInfo;


